exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dmb-web__WeatherForecastContainer__title__wMH27 {\n  font-size: 24px;\n  font-weight: 200;\n  margin: 12px 0;\n}\n\n.dmb-web__WeatherForecastContainer__weatherForecastContainer__c7U1A {\n  width: 100%;\n}", ""]);

// exports
exports.locals = {
	"title": "dmb-web__WeatherForecastContainer__title__wMH27",
	"weatherForecastContainer": "dmb-web__WeatherForecastContainer__weatherForecastContainer__c7U1A"
};